export const applicationErrors = {
  not_found: new Error('404'),
};
